import Vue from 'vue'

class CustomerRepository {

  controller = {}

  search(data, instanceId = 'default') {
    return new Promise((resolve, reject) => {


        if(this.controller[instanceId]) {
            this.controller[instanceId].abort()
        }
        this.controller[instanceId] = new AbortController()


        Vue.auth.fetch({
        url: '/api/customer/search',
        method: 'post',
        data,
        signal: this.controller[instanceId].signal,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/get/' + id,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getByIdentifier(identifier) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/by-identifier/' + identifier,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }


  create(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  update(id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/update/' + id,
        method: 'post',
        data
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  startClientSpaceImpersonation(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/customer/${id}/client-space-impersonation`,
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  unlockLogin(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/customer/${id}/unlock-login`,
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }


  addHomeChargingPoint(id, chargingPointId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/home-charging-point',
        method: 'post',
        data: {
          chargingPointId
        }
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  deleteHomeChargingPoint(id, chargingPointId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/home-charging-point/' + chargingPointId,
        method: 'delete',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  addFreeOrganization(id, organizationId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/free-organization',
        method: 'post',
        data: {
          organizationId
        }
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  deleteFreeOrganization(id, organizationId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/free-organization/' + organizationId,
        method: 'delete',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  requestMeterDeviceReadings(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/request-meter-device-readings',
        method: 'post',
      }).then(response => {
          resolve(response.data)
      }).catch(err => {
          reject(err)
      })
    })
  }

  suspend(id, reason) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/suspend',
        method: 'post',
        data: {
          reason
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  reactivate(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/customer/' + id + '/reactivate',
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // L'historique de connexion d'un client (développeurs) : en GET, les paramètres passent par `data`.
  loginAttempts(id, data = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/customer/${id}/login-attempts`,
        method: 'get',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}


export default new CustomerRepository()
